import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-remove-selected-item-message',
  templateUrl: './remove-selected-item-message.component.html',
  styleUrls: ['./remove-selected-item-message.component.scss']
})
export class RemoveSelectedItemMessageComponent implements OnInit {

  @Input() orderLineGuid : string;

  @Output() closeDialog = new EventEmitter();
  @Output() removeItem = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onClickRemove(){
    this.removeItem.emit(this.orderLineGuid);
  }

  onClickCancel(){
    this.closeDialog.emit();
  }

}
